
"use client";

import React, { useEffect, useState } from "react";
import { useStepperContext } from "../StepperContext";
import { useDispatch } from "react-redux";
import {
  addCitizenship,
  addCountry,
  addDob,
  addEmail,
  addFName,
  addLName,
  addPNum,
  addCity,
  addFreelanceEmailError,
  addFreelancePhoneError,
  addFirstnameError,
  addLastnameError,
  addDobError,
  addCountryError,
  addCityError,
  addCitizenshipError,
} from "@/lib/redux/Features/freelancerSlice";
import { countries } from 'countries-list';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";



// Regular Expressions
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;
const firstNameRegex = /^[A-Z][a-z]*([-'][A-Z][a-z]*)*$/;
const lastNameRegex = /^[A-Z][a-z]*([-'][A-Z][a-z]*)*$/;

export default function Account() {
  const dispatch = useDispatch();


  const { userData, setUserData } = useStepperContext();
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [firstnameError, setFirstnameError] = useState("");
  const [lastnameError, setLastnameError] = useState("");
  const [dobError, setDobError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [cityError, setCityError] = useState("");
  const [citizenshipError, setCitizenshipError] = useState("");
  const [countryList, setCountryList] = useState([]);

  // Countries List Update
  useEffect(() => {
    const country = Object.values(countries).map(country => ({
      name: country.name,
      code: country.phone
    }));
    setCountryList(country);
  }, [setCountryList]);

  const handlePhoneChange = (value) => {
    setUserData({ ...userData, phoneNumber: value });
    dispatch(addPNum(value));
  };

  // console.log(process.env.SECRETACCESSKEY);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });

    // Dispatch actions based on the field name
    if (name === "firstName") {
      dispatch(addFName(value));
    } else if (name === "lastName") {
      dispatch(addLName(value));
    } 
    // else if (name === "phoneNumber") {
    //   dispatch(addPNum(value));
    // } 
    else if (name === "email") {
      dispatch(addEmail(value));
    } else if (name === "dateOfBirth") {
      dispatch(addDob(value));
    } else if (name === "country") {
      dispatch(addCountry(value));
    } else if (name === "city") {
      dispatch(addCity(value));
    } else if (name === "citizenship") {
      dispatch(addCitizenship(value));
    }

    // Validation
    if (name === "email") {
      if (value.trim() === "") {
        setEmailError("Email is required");
        dispatch(addFreelanceEmailError("yes"));
      } else if (!emailRegex.test(value)) {
        setEmailError("Please enter a valid email address");
        dispatch(addFreelanceEmailError("yes"));
      } else {
        setEmailError("");
        dispatch(addFreelanceEmailError(null));
      }
    }

    if (name === "phoneNumber") {
      if (value.trim() === "") {
        setPhoneError("Phone number is required");
        dispatch(addFreelancePhoneError("yes"));
      } else if (!phoneRegex.test(value)) {
        setPhoneError("Please enter a valid 10-digit phone number");
        dispatch(addFreelancePhoneError("yes"));
      } else {
        setPhoneError("");
        dispatch(addFreelancePhoneError(null));
      }
    }

    if (name === "firstName") {
      if (value.trim() === "") {
        setFirstnameError("First name is required");
        dispatch(addFirstnameError("yes"));
      } else if (!firstNameRegex.test(value)) {
        setFirstnameError("Please enter a valid first name");
        dispatch(addFirstnameError("yes"));
      } else {
        setFirstnameError("");
        dispatch(addFirstnameError(null));
      }
    }

    if (name === "lastName") {
      if (value.trim() === "") {
        setLastnameError("Last name is required");
        dispatch(addLastnameError("yes"));
      } else if (!lastNameRegex.test(value)) {
        setLastnameError("Please enter a valid last name");
        dispatch(addLastnameError("yes"));
      } else {
        setLastnameError("");
        dispatch(addLastnameError(null));
      }
    }

    if (name === "dateOfBirth") {
      if (value.trim() === "") {
        setDobError("Date of birth is required");
        dispatch(addDobError("yes"));
      } else {
        setDobError("");
        dispatch(addDobError(null));
      }
    }

    if (name === "country") {
      if (value.trim() === "") {
        setCountryError("Country is required");
        dispatch(addCountryError("yes"));
      } else {
        setCountryError("");
        dispatch(addCountryError(null));
      }
    }

    if (name === "city") {
      if (value.trim() === "") {
        setCityError("City is required");
        dispatch(addCityError("yes"));
      } else {
        setCityError("");
        dispatch(addCityError(null));
      }
    }

    if (name === "citizenship") {
      if (value.trim() === "") {
        setCitizenshipError("Citizenship is required");
        dispatch(addCitizenshipError("yes"));
      } else {
        setCitizenshipError("");
        dispatch(addCitizenshipError(null));
      }
    }
  };

  // Calendar till today logic
  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row">
          <div className="mx-2 flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              First Name*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <input
                onChange={handleChange}
                value={userData["firstName"] || ""}
                name="firstName"
                placeholder="First Name"
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
              />
            </div>
            {firstnameError && <span className="text-red-500">{firstnameError}</span>}
          </div>
          <div className="mx-2 flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              Last Name*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <input
                onChange={handleChange}
                value={userData["lastName"] || ""}
                name="lastName"
                placeholder="Last Name"
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
              />
            </div>
            {lastnameError && <span className="text-red-500">{lastnameError}</span>}
          </div>
        </div>
        <div className="flex flex-row">
          <div className="mx-2 w-full flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              Phone Number*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              {/* <select
                onChange={handleChange}
                value={userData["countryCode"] || ""}
                name="countryCode"
                className="w-[40px] appearance-none p-1  text-gray-800 outline-none">
                <option value="">+91</option>
                {countryList.map((country, index) => (
                  <option key={index} value={country.code}>
                    +{country.code}
                  </option>
                ))}
              </select>
              <input
                onChange={handleChange}
                type="phone"
                value={userData["phoneNumber"] || ""}
                name="phoneNumber"
                placeholder="Phone"
                className="w-3/4 appearance-none p-1 px-2 text-gray-800 outline-none"
              /> */}
              <PhoneInput
                country={"in"}
                countryCallingCodeEditable={false}
                onChange={handlePhoneChange}
                value={userData["phoneNumber"] || ""}
                name="phoneNumber"
                placeholder="Phone"
                className="w-full appearance-none   text-gray-800 outline-none"
              />

            </div>
            {phoneError && <span className="text-red-500">{phoneError}</span>}
          </div>
          <div className="mx-2 w-full flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              Email*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <input
                onChange={handleChange}
                value={userData["email"] || ""}
                name="email"
                placeholder="Email"
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
              />
            </div>
            {emailError && <span className="text-red-500">{emailError}</span>}
          </div>
        </div>
        <div className="flex flex-row">
          <div className="mx-2 w-full flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              Date of Birth*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <input
                onChange={handleChange}
                value={userData["dateOfBirth"] || ""}
                name="dateOfBirth"
                placeholder="Date of Birth"
                type="date"
                max={today}
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
              />
            </div>
            {dobError && <span className="text-red-500">{dobError}</span>}
          </div>
          <div className="mx-2 w-full flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              Country*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <select
                onChange={handleChange}
                value={userData["country"] || ""}
                name="country"
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none">
                <option value="">Country</option>
                {countryList.map((country, index) => (
                  <option key={index} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
            {countryError && <span className="text-red-500">{countryError}</span>}
          </div>
        </div>
        <div className="flex flex-row">
          <div className="mx-2 flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              City*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <input
                onChange={handleChange}
                value={userData["city"] || ""}
                name="city"
                placeholder="City"
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
              />
            </div>
            {cityError && <span className="text-red-500">{cityError}</span>}
          </div>
          <div className="mx-2 flex-1">
            <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500">
              Citizenship*
            </div>
            <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
              <input
                onChange={handleChange}
                value={userData["citizenship"] || ""}
                name="citizenship"
                placeholder="Citizenship"
                className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
              />
            </div>
            {citizenshipError && <span className="text-red-500">{citizenshipError}</span>}
          </div>
        </div>
      </div>
    </>
  );
}